































import { Component, Vue } from 'vue-property-decorator'
import { ActionTypes } from '@/store/action-types'
import { LOCALES } from '@/i18n/locales'
import { defaultLocale } from '@/i18n'

@Component({
  data: () => ({ LOCALES, defaultLocale })
})
export default class UserMenuDropdown extends Vue {
  private logout() {
    this.$store.dispatch(ActionTypes.AUTH_LOGOUT)
  }

  private setLocale(event: { target: { value: string } }) {
    this.$i18n.locale = event.target.value
    this.$store.commit('SET_ACTIVE_LANG', this.$i18n.locale)
    localStorage.setItem('userLocale', this.$i18n.locale)

    // Reload page
    window.location.reload()
  }

  async created() {
    if (!this.$store.state.user.username) {
      await this.$store.dispatch(ActionTypes.USER_REQUEST)
    }
  }
}
